import { Component, HostListener, ElementRef } from '@angular/core';
import { Router, NavigationEnd, RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'app-navbar',
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
})
export class NavbarComponent {
  isMenuOpen = false;

  // after router link is clicked, always close the menu
  constructor(private router: Router, private eRef: ElementRef) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.isMenuOpen = false;
      }
    });
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
    console.log('toggle')
  }

  @HostListener('document:click', ['$event'])
  clickout(event: Event) {
    // If the menu is open AND the click was NOT inside this component, close menu
    if (this.isMenuOpen && !this.eRef.nativeElement.contains(event.target)) {
      this.isMenuOpen = false;
    }
  }

  openExternalLink(url: string): void {
    this.isMenuOpen = false;
    window.open(url, '_blank', 'noopener,noreferrer');
  }

}
